"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sizes = require("@decisiv/design-tokens/lib/iconography/sizes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SvgSend = function SvgSend(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: _sizes.alias[size],
    height: _sizes.alias[size],
    color: color,
    focusable: "false"
  }, props), _react.default.createElement("path", {
    d: "M12.563 4.854L8.217 9.199l1.63 3.26 2.716-7.605zm-5.76 2.931l4.345-4.346-7.605 2.717 3.26 1.63zm-6.25-.889c-.788-.393-.719-1.54.11-1.836l14-5a1 1 0 011.279 1.278l-5 14c-.296.83-1.443.899-1.836.111L6.255 9.747.553 6.897z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

SvgSend.propTypes = {
  size: _propTypes.default.oneOf(Object.keys(_sizes.alias)),
  color: _propTypes.default.string
};
var _default = SvgSend;
exports.default = _default;